import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'umarex',
} as IModuleProps;
